export default __webpack_public_path__ + "static/media/newDFA-logo.88d3af52.svg";